"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_PARAM = exports.CUSTOMER_ID = exports.FACILITY_ID = exports.AUTH_HEADER = exports.CLOUD_FUNCTION_URL = void 0;
exports.CLOUD_FUNCTION_URL = 'https://europe-west3-named-catcher-373207.cloudfunctions.net/fitpos';
exports.AUTH_HEADER = "app-auth";
exports.FACILITY_ID = "facilityId";
exports.CUSTOMER_ID = "id";
exports.AUTH_PARAM = "auth";
